import React from "react";
import styles from "./rate_plan_policies.module.css";
import classNames from "classnames";

export default function CancellationBadge({ cancellationPolicy, isMobile = false }) {
  return (
    <>
      {(cancellationPolicy && cancellationPolicy?.cancellationPolicyLogic === "free") ||
        (cancellationPolicy?.cancellationPolicyLogic === "deadline" && (
          <div
            className={classNames(styles.badge, {
              [styles.badgeMobile]: isMobile,
            })}
          >
            <span>Free cancellation</span>
          </div>
        ))}
    </>
  );
}
